import { useContext, useEffect, useState } from "react";
import { AppContext } from "../App";
import { getInlineLoader } from "../Helpers";
import { IoArrowForward } from "react-icons/io5";

import banner1 from "../assets/banner3.jpg";
import banner3 from "../assets/packaging.jpg";
import ppe from "../assets/banner4.jpg";
import chemicals from "../assets/banner2.jpg";

export default function HomeBanner4() {
  const appContext = useContext(AppContext);
  const [ready, setReady] = useState(false);
  const services = [
    {
      title: "Seed Production and Multiplication",
      description: "Climate-resilient seed production at scale.",
      image: banner1,
      alt: "Seed Production and Multiplication",
      subItem: "seed",
    },
    {
      title: "Processing and Packaging",
      description: "Efficient processing for quality and shelf life.",
      image: banner3,
      alt: "Processing and Packaging",
      subItem: "processing",
    },
    {
      title: "Agrochemical, Fertilizers and Seed Distribution",
      description: "Reliable distribution of essential farm inputs.",
      image: chemicals,
      alt: "Agrochemical, Fertilizers and Seed Distribution",
      subItem: "agrochemical",
    },
    {
      title: "Supply of Day-Old Chicks and Poultry Feed",
      description: "Trusted poultry inputs for stronger farm output.",
      image: ppe,
      alt: "Supply of Day-Old Chicks and Poultry Feed",
      subItem: "poultry",
    },
  ];

  useEffect(() => {
    setReady(true);
  }, []);

  if (!ready) {
    return (
      <div className="container mSupportLoading">
        {getInlineLoader()}
      </div>
    );
  }

  return (
    <section
      className="MainBodySection py-5"
      style={{
        background:
          "radial-gradient(circle at 88% 16%, rgba(7, 135, 90, 0.14), transparent 40%), linear-gradient(180deg, #f6fbf8 0%, #ffffff 100%)",
      }}
    >
      <div className="container" style={{ maxWidth: "1140px", margin: "40px auto", padding: "0 20px" }}>
        <div className="text-center mb-4 mb-lg-5" data-aos="fade-up">
          <h2 className="text-primary font-bold mb-2">We Specialize In</h2>
          <p className="text-muted mb-0">
            Modern agribusiness solutions built on quality, precision, and farmer success.
          </p>
        </div>

        <div className="row g-4">
          {services.map((service) => (
            <div className="col-12 col-md-6" key={service.title}>
              <article
                className="h-100 d-flex flex-column"
                onClick={() => appContext.navTo({ item: "services", subItem: service.subItem })}
                style={{
                  cursor: "pointer",
                  borderRadius: "20px",
                  overflow: "hidden",
                  background: "#ffffff",
                  border: "1px solid rgba(15, 23, 42, 0.08)",
                  boxShadow: "0 14px 28px rgba(15, 23, 42, 0.09)",
                  transition: "transform .28s ease, box-shadow .28s ease",
                }}
                onMouseEnter={(e) => {
                  e.currentTarget.style.transform = "translateY(-6px)";
                  e.currentTarget.style.boxShadow = "0 20px 34px rgba(15, 23, 42, 0.13)";
                }}
                onMouseLeave={(e) => {
                  e.currentTarget.style.transform = "translateY(0)";
                  e.currentTarget.style.boxShadow = "0 14px 28px rgba(15, 23, 42, 0.09)";
                }}
              >
                <div style={{ height: "210px", overflow: "hidden" }}>
                  <img
                    src={service.image}
                    alt={service.alt}
                    style={{ width: "100%", height: "100%", objectFit: "cover", display: "block" }}
                  />
                </div>
                <div className="p-4 d-flex flex-column flex-grow-1">
                  <h5 className="text-primary font-bold mb-3">{service.title}</h5>
                  <p className="text-muted mb-0" style={{ lineHeight: 1.65 }}>
                    {service.description}
                  </p>
                  <div
                    className="d-flex justify-content-between align-items-center mt-4 pt-3"
                    style={{ borderTop: "1px solid rgba(15, 23, 42, 0.10)" }}
                  >
                    <span
                      className="font-semi-bold"
                      style={{
                        letterSpacing: "0.05em",
                        textTransform: "uppercase",
                        fontSize: "0.8rem",
                        color: "var(--primaryColor)",
                      }}
                    >
                      Explore
                    </span>
                    <span
                      style={{
                        width: "34px",
                        height: "34px",
                        borderRadius: "50%",
                        border: "1px solid rgba(7, 135, 90, 0.35)",
                        background: "rgba(7, 135, 90, 0.08)",
                        color: "var(--primaryColor)",
                        display: "grid",
                        placeItems: "center",
                        fontSize: "16px",
                      }}
                    >
                      <IoArrowForward />
                    </span>
                  </div>
                </div>
              </article>
            </div>
          ))}
        </div>
      </div>
    </section>
  );
}
